import React, {Fragment} from 'react'
import {Listbox, Transition} from '@headlessui/react'
import {HiSelector} from "@react-icons/all-files/hi/HiSelector";
import {FiCheck} from "@react-icons/all-files/fi/FiCheck";

const SingleSelect = ({name, selectedValue, setSelected, options, label}: {name: string, selectedValue?:any, setSelected?: (val: any, name: string) => void, options: any[], label?: string}) => {

    return (
        <div className="w-full">
            <label className={"text-xs tracking-widest uppercase font-bold font-display opacity-80"}>
                {label}
            </label>
            <Listbox value={selectedValue?.name} onChange={(value) => { if (setSelected) setSelected({name: value}, name); }}>
                <div className="relative mt-1">
                    <Listbox.Button
                        className="relative w-full py-2 pl-3 pr-10 text-left bg-white rounded-md shadow-sm border border-gray-300 cursor-default focus:outline-none ring-1 ring-transparent focus:ring-zinc-800 focus:z-20 sm:text-base focus:border-lime-300"
                        style={{ background: "#f7f8f2" }}
                    >
                        <span className={`block truncate ${!selectedValue ? "text-gray-500" : ""}`}>{!selectedValue ? "Select an Option" : selectedValue.name}</span>
                        <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                            <HiSelector
                                className="w-5 h-5 text-gray-400"
                                aria-hidden="true"
                            />
                        </span>
                    </Listbox.Button>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        enter={"transition ease-in duration-100"}
                        enterTo="opacity-100"
                        enterFrom="opacity-0"
                    >
                        <Listbox.Options
                            className="absolute w-full mt-1 overflow-auto text-base rounded-md shadow-lg max-h-32 z-40 border border-gray-200 focus:outline-none sm:text-base"
                            style={{ background: "#fefff5" }}
                        >
                            {options.map((option, index) => (
                                <Listbox.Option
                                    key={index}
                                    className={({active}) => `${active ? 'text-zinc-900 bg-lime-100' : 'text-gray-900'} cursor-pointer select-none relative py-2 pl-10 pr-4`}
                                    value={option.name}
                                >
                                    {
                                        ({selected, active}) => (
                                            <>
                                                <span className={`${selected ? 'font-medium' : ''} block truncate`}>
                                                    {option.name}
                                                </span>
                                                {selected ?
                                                    <span className={`${active ? 'text-primary-default' : 'text-primary-light'} absolute inset-y-0 left-0 flex items-center pl-3`}>
                                                      <FiCheck className="w-5 h-5" aria-hidden="true"/>
                                                    </span>
                                                    :
                                                    <span className={`${active ? 'text-primary-default' : 'text-gray-300'} absolute inset-y-0 left-0 flex items-center pl-3`}>
                                                      <FiCheck className="w-4 h-4" aria-hidden="true"/>
                                                    </span>
                                                }
                                            </>
                                        )
                                    }
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </Transition>
                </div>
            </Listbox>
        </div>
    )
}

export default SingleSelect;